import React from "react";
import { Modal } from "react-bootstrap";
import CommingSoon from "../comming-soon/CommingSoon";

export default class CommingSoonModal extends React.PureComponent<{ showModal: boolean, closeModal: any }, {}> {


    render(): React.ReactNode {
        let { closeModal, showModal } = this.props;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title dir="rtl">
                        <div className="text-center">
                        این بخش به زودی فعال میشود
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{textAlign: 'center'}}>
                        <CommingSoon />
                    </div>
                </Modal.Body >
                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}